export default __webpack_public_path__ + "static/media/358-paper-plane.ec8aead3.svg";